



















import { useNosnippet } from '@common/util';
import { defineComponent } from '@vue/composition-api';

export default defineComponent({
    props: {
        
    },
    setup(props, { root }: any) {
        root.$store.dispatch('getInitMetaData');
        root.$store.dispatch('getInitData');
        root.$store.dispatch('getLocalLang');

        const {
            initData: { locale, isRtl, query },
            mobile: { initMetaData },
        } = root.$store.state;
        
        delete root.$store.state.mobile;
        delete root.$store.state.opengraph;
        
        const isNode: boolean = EASY_ENV_IS_NODE;
        const dir = isRtl ? 'rtl' : 'ltr';
        const useNosnippetResult = useNosnippet(query?.source);

        return {
            isNode,
            locale,
            dir,
            initMetaData,
            useNosnippetResult,
        };
    },
});
